<template>
  <f7-tab
    class="parts-tab"
    :tab-active="tabActive"
  >
    <UCPreload
      v-if="isLoadingWorkParts"
      :show="isLoadingWorkParts"
      :number="3"
    />

    <template v-else>
      <f7-block class="parts-tab-block">
        <template v-if="workParts">
          <ul
            v-if="workParts.length > 0"
            class="parts-tab-list"
          >
            <TransitionGroup>
              <PCPartsItemCard
                v-for="(workPart, index) in workParts"
                :key="index"
                :work-part="workPart"
              />
            </TransitionGroup>
          </ul>

          <PCPartsTabNoItems
            v-else
            class="parts-no-items"
          />
        </template>
      </f7-block>
    </template>
  </f7-tab>
</template>

<script setup>
// @ts-check

import { useRepairParts } from '@/composables/useRepairParts';

import UCPreload from '@/components/common/UCPreload.vue';
import PCPartsItemCard from './PCPartsItemCard.vue';
import PCPartsTabNoItems from './PCPartsTabNoItems.vue';

defineProps({
  tabActive: { type: Boolean, default: false },
});

const { workParts, isLoadingWorkParts } = useRepairParts();
</script>

<style scoped lang="scss">
.parts-tab {
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
}

.parts-tab-block {
  display: flex;
  justify-content: center;
  --available-viewport-height: calc(100vh - var(--information-bar-height));

  // information bar, navbar, toolbar
  max-height: calc(var(--available-viewport-height) - var(--f7-navbar-height) - 76px);

  .parts-tab-list {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 75%;
    list-style: none;
    padding: 0;
  }

  // Center the 'there are no work parts' text
  &:has(.parts-no-items) {
    display: flex;
    margin: 0;
    height: 100%;
  }
}
</style>
